import { ISubscriptionPlan } from '../interface/ISubscriptionPlan'

export const initialState: ISubscriptionPlan = {
  moduleId: 0,
  title: '',
  price: {
    be: 0,
    nl: 0,
  },
  isBestPick: false,
  features: [],
}
